import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import { User } from '@supabase/supabase-js';

export interface AuthState {
  user: User | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  signOut: () => Promise<void>;
  checkSession: () => Promise<boolean>;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ isLoading: loading }),
  signOut: async () => {
    await supabase.auth.signOut();
    set({ user: null });
  },
  checkSession: async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        set({ user: null, isLoading: false });
        return false;
      }

      // Periksa jika token masih sah
      if (session.expires_at && new Date(session.expires_at * 1000) < new Date()) {
        // Token sudah tamat tempoh
        await supabase.auth.signOut();
        set({ user: null, isLoading: false });
        return false;
      }

      // Jika user ada dan token sah, perbarui user data
      set({ user: session.user, isLoading: false });
      return true;
    } catch (error) {
      console.error('Session check error:', error);
      set({ user: null, isLoading: false });
      return false;
    }
  }
}));